
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import DrinksScreens from './drink'

function Index({ setshowCategories, type }) { 
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);
    
          useEffect(() => {
                menus.map((item) => {
                    if (item.id === 479) {
                        setdrinks(item);
                    }
                });
          }, [menus]);
        
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={() => {
            setShowSpecials(true)
        }}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 765}}>

                   <div
                        style={{
                            display: 'flex',
                            paddingHorizontal: 20,
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}>
                        <img
                            src={
                            type === 'mexicam'
                                ? require('./assets/mexiam.png')
                                : type === 'aguanatural'
                                ? require('./assets/natural.png')
                                : type === 'jugosnatural'
                                ? require('./assets/jugos.png')
                                : type === 'batidos'
                                ? require('./assets/batidos.png')
                                : type === 'limonadas'
                                ? require('./assets/limonadas.png')
                                : type === 'hotdrink'
                                ? require('./assets/hotdrink.png')
                                : require('./assets/image.png')
                            }
                            style={{
                            marginTop: 80,
                            width: '100%',
                            height:  type === 'mexicam'? 400: 540,
                            objectFit: 'contain',
                            borderRadius: 40,
                            alignSelf: 'center',
                            }}
                        />
                    </div>
                    
                </div>

                {type === 'mexicam' &&
                <img
                            src={
                           require('./assets/mexicamsodas.png')
                            }
                    style={{
                                position: 'absolute',
                            width: 500,
                            height:  500,
                            objectFit: 'cover',
                            borderRadius: 40,
                        alignSelf: 'center',
                        bottom: -60,
                            left: 70,
                            }}
                        />
                }

                {type === 'aguanatural' &&
                <img
                            src={
                           require('./assets/agua1.png')
                            }
                    style={{
                                position: 'absolute',
                            width: 400,
                            height:  400,
                            objectFit: 'contain',
                            borderRadius: 40,
                        alignSelf: 'center',
                        bottom: -60,
                            left: -70,
                            }}
                        />
                }

                {type === 'aguanatural' &&
                <img
                            src={
                           require('./assets/agua2.png')
                            }
                    style={{
                                position: 'absolute',
                            width: 400,
                            height:  400,
                            objectFit: 'contain',
                            borderRadius: 40,
                        alignSelf: 'center',
                        bottom: -60,
                            right: -70,
                            }}
                        />
                }

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                 {showDrinks && <DrinksScreens goBack={setShowDrinks}  goHome={setshowCategories} />}
            </LayoutContent>
        </div>
    );
}
export default Index;